import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom'
import { ReactSession } from 'react-client-session';

import '../Dashboard.css';
import classes from "./Subscriptions.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";


function Home() {
    const [subscription, setSubscription] = useState(false);
  ReactSession.setStoreType("localStorage");
  const logged_user = ReactSession.get('logged_user');

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/user/has_premium.php`, {
        user_id: logged_user,
      }, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }).then(res => {
        // console.log(res.data);
        setSubscription(res.data);
      })
  }, [])

  return (
    <div className="container_wrapper">
      <Header />
      <div className={`${styles.main} main`}>
        <Sidebar active="subscriptions" />
        <div className={styles.main_content}>
            <div className={styles.content_body}>
                <div className={classes.isBoxed}>
                    <h3>Premium subscriptions</h3>
                    {
                        subscription.validity_until ? <>
                            {
                                !subscription.expired_on ? <div className={`${classes.alert} alert alert-success`} role="alert">You are a premium member until {subscription.validity_until}</div>
                                : <div className={`${classes.alert} alert alert-danger`} role="alert"><Link to="/dashboard/payment">Premium expired on {subscription.expired_on}</Link></div>
                            }
                        </>
                        : <div className={`${classes.alert} alert alert-success`} role="alert"><Link to="/dashboard/payment"><i className="fa-solid fa-medal"></i> Why not try premium?</Link></div>
                    }
                    <div className={classes.divider}></div>
                    <h5>Transactions</h5>
                    {
                        subscription.payments && subscription.payments.map ? subscription.payments.map((paid, index) => {
                            let date = new Date(paid.valid_to);
                            return(
                                <div className={classes.block} key={index}>
                                    <span id={classes.badge}>{paid.payment_gross} {paid.currency_code} </span> {paid.valid_from} with {paid.payment_method} {paid.payer_email} for premium until {date.toISOString().slice(0,10)}
                                </div>
                            )
                        })
                        : <div className={`${classes.alert} alert alert-info`} role="alert">No past subscriptions</div>
                    }
                </div>
            </div>
            <Footer />
        </div>
      </div>
    </div>
  );
}

export default Home;